<template>
  <v-dialog
    v-model="show"
    scrollable
    :overlay="true"
    max-width="500px"
    transition="dialog-transition"
  >
    <v-card>
      <v-card-title class="body-1">
        {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.PENALTY_APPEAL_COMMENTS') }}
        <v-spacer></v-spacer>
        <v-btn icon small @click="close()">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-subtitle class="pt-2">
        {{ place.name }}
      </v-card-subtitle>
      <v-card-text class="pa-0">
        <v-form v-model="formValid">
          <v-container>
            <v-row class="d-flex align-center">
              <v-col cols="12" sm="12">
                <v-textarea
                  v-model="penaltyAppealComments"
                  :label="
                    $vuetify.lang.t(
                      '$vuetify.ENFORCEMENT.PENALTY_APPEAL_COMMENTS'
                    )
                  "
                  outlined
                  autofocus
                  rows="8"
                  counter="1024"
                  :rules="commentRules"
                >
                </v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close()">
          {{ $vuetify.lang.t('$vuetify.CANCEL') }}
        </v-btn>
        <v-btn
          color="primary"
          class="secondary--text"
          text
          :disabled="!formValid"
          :loading="
            loading.state && loading.type === 'putPlacePenaltyAppealComments'
          "
          @click="save()"
        >
          {{ $vuetify.lang.t('$vuetify.SAVE') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

const MAX_LENGTH = 1024

export default {
  name: 'EditPenaltyAppealCommentsDialog',
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    place: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      formValid: true,
      penaltyAppealComments: this.place.penaltyAppealComments || '',
      commentRules: [
        v =>
          (v || '').length <= MAX_LENGTH ||
          this.$vuetify.lang.t('$vuetify.ENFORCEMENT.COMMENTS_TOO_LONG')
      ]
    }
  },
  computed: {
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      }
    },
    ...mapGetters('app', ['loading'])
  },
  methods: {
    ...mapActions('enforcement', ['putPlacePenaltyAppealComments']),
    save() {
      this.putPlacePenaltyAppealComments({
        placeId: this.place.id,
        penaltyAppealComments: this.penaltyAppealComments
      }).then(() => {
        this.close()
      })
    },
    close() {
      this.show = false
    }
  }
}
</script>
